import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useAudienceDirectory } from '../../../lib/audience/useAudienceDirectory';
import { authzClient } from '../../../lib/connect';
const MIN_PEOPLE_QUERY = 2;
/**
 * Directory for "Who can see this": teams/groups from the member-projected
 * audience directory (same source as Library releases) and people from
 * SearchTenantMembers (display names only, never email).
 */ export function useHearsayAudienceDirectory(enabled) {
    const [teamQuery, setTeamQuery] = useState('');
    const [peopleQuery, setPeopleQuery] = useState('');
    const [debouncedPeople, setDebouncedPeople] = useState('');
    useEffect(()=>{
        const t = setTimeout(()=>setDebouncedPeople(peopleQuery.trim()), 250);
        return ()=>clearTimeout(t);
    }, [
        peopleQuery
    ]);
    const teams = useAudienceDirectory(teamQuery, enabled);
    const people = useQuery({
        queryKey: [
            'hearsay-audience-people',
            debouncedPeople
        ],
        enabled: enabled && debouncedPeople.length >= MIN_PEOPLE_QUERY,
        queryFn: async ()=>{
            const resp = await authzClient.searchTenantMembers({
                query: debouncedPeople,
                limit: 20
            });
            return resp.members;
        }
    });
    const teamOptions = teams.choices.map((c)=>({
            kind: c.kind === 'scope_node' ? 'SCOPE_NODE' : 'PRINCIPAL_GROUP',
            id: c.scopeNodeId || c.principalGroupId,
            label: c.name
        }));
    const peopleOptions = (people.data ?? []).map((m)=>({
            kind: 'USER',
            id: m.id,
            label: m.displayName
        }));
    return {
        teamOptions,
        teamQuery,
        onTeamQueryChange: setTeamQuery,
        teamsLoading: teams.loading,
        teamsError: teams.error,
        onTeamsRetry: teams.retry,
        peopleOptions,
        peopleQuery,
        onPeopleQueryChange: setPeopleQuery,
        peopleLoading: people.isFetching,
        peopleError: people.isError,
        onPeopleRetry: ()=>void people.refetch()
    };
}
